import { defAlias, defBaseUnit } from '../registry';

export const countUnits = [defBaseUnit('count', {})];

defAlias('null', 'count');
defAlias('order', 'count');
defAlias('orders', 'count');
defAlias('employee', 'count');
defAlias('employees', 'count');
defAlias('commercial_flights', 'count');
defAlias('private_flight', 'count');
defAlias('night', 'count');
defAlias('nights', 'count');
defAlias('currency', 'count');
defAlias('hotel', 'count');
defAlias('hotel-night', 'count');
defAlias('guest', 'count');
defAlias('guest-night', 'count');
defAlias('room', 'count');
defAlias('dip', 'count');
defAlias('tap', 'count');
defAlias('swipe', 'count');
defAlias('passenger', 'count');
defAlias('entree', 'count');
defAlias('side', 'count');
defAlias('drink', 'count');
defAlias('payment_card_produced', 'count');
defAlias('digital_impression', 'count');
defAlias('experience_seat', 'count');
defAlias('vehicle', 'count');
defAlias('truck', 'count');
defAlias('transaction', 'count');
defAlias('product', 'count');

// Aliases from legacy footprint `unit` column.
defAlias('none', 'count');
defAlias('payment_cards_produced', 'count');
defAlias('units', 'count');
defAlias('attribution_factor', 'count');
defAlias('drive', 'count');
defAlias('server', 'count');

// Aliases from finance
defAlias('score', 'count');
defAlias('M', 'count'); // "millions" of preferred currency
defAlias('ownership', 'count');
defAlias('asset', 'count');
defAlias('holding', 'count');
